export default "__VITE_ASSET__B_NR8nIm__"